import crown from "@/assets/crown.png";

export const LoadingScreen = () => (
  <div
    className="min-h-screen bg-[#0B0B0F] flex flex-col items-center justify-center gap-5"
    data-testid="loading-screen"
  >
    <img src={crown} alt="THE CIRCLE" className="w-16 h-16 crown-glow" />
    <p className="text-[#A0A0A0] text-xs tracking-[0.35em] uppercase font-medium">
      The Circle
    </p>
  </div>
);
